import { useRef, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function PrintLabel() {
  const documentRef = useRef();
  const query = useQuery();
  const handlePrint = useReactToPrint({
    content: () => documentRef.current,
    onAfterPrint: () => window.close(),
  });
  const label = query.get('label');
  const number = Number(query.get('number'));

  useEffect(() => {
    if (documentRef.current && label && number) {
      handlePrint();
    }
    // eslint-disable-next-line
  }, [documentRef]);

  if (!label || !number) {
    return null;
  }

  return (
    <>
      <div className="print-label" ref={documentRef}>
        <style type="text/css" media="print">
          {`
            @page {
              margin: 0mm;
              size: 20cm 10cm;
            }
          `}
        </style>

        {[...Array(number)].map((_, i) => (
          <div className="label" key={i}>
            <p>
              {i + 1}/{number}
            </p>
            <p>{label}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export default PrintLabel;
